/**
 * SketchesEntry — client view of a "Sketch ribbon" journey entry: an optional lead-in note plus a
 * swipeable ribbon of sketches/renderings (tap to enlarge). Reads entry.data.sketches; the entry is
 * only visible to the client once published (the public journey endpoint filters published=true).
 *
 * When this card becomes the ACTIVE card in the Hub (not just a neighbor peeking in the carousel),
 * the project channel is told the client is looking at it — once per visit, never in preview mode
 * (notifySketchRibbonViewed, services/journey.js).
 */

import { useEffect } from 'react'
import Markdown from '../../components/Markdown.jsx'
import { J } from '../journeyUI.jsx'
import SketchRibbon from '../SketchRibbon.jsx'
import { notifySketchRibbonViewed } from '../../services/journey.js'

export default function SketchesEntry({ entry, project, token, isActive, previewMode }) {
  const sketches = (entry.data && Array.isArray(entry.data.sketches)) ? entry.data.sketches : []
  useEffect(() => {
    if (isActive && !previewMode && sketches.length) notifySketchRibbonViewed(token, entry.id)
  }, [isActive, previewMode, token, entry.id, sketches.length])
  return (
    <div>
      <div style={J.eyebrow}>Sketches</div>
      <h2 style={J.title}>{entry.title || 'Sketches & renderings'}</h2>
      <hr style={J.rule} />
      {entry.data?.intro && (
        <div style={{ ...J.body, marginBottom: 18 }}><Markdown text={entry.data.intro} /></div>
      )}
      {sketches.length
        ? <SketchRibbon sketches={sketches} projectId={project?.id} token={token} />
        : <div style={{ ...J.body, fontStyle: 'italic', color: '#7a9aaa' }}>These are being prepared.</div>}
    </div>
  )
}
